module.exports = __webpack_public_path__ + "img/license.150b002f.jpg";